import { Toaster } from "sonner";
import { useEffect, useState } from "react";

const RTL_TOAST_CLASS = "rtl-sonner-toast";

const detectRTL = () => {
  if (typeof document === "undefined") {
    return false;
  }

  if (document.documentElement.dir === "rtl" || document.body?.dir === "rtl") {
    return true;
  }

  return Boolean(document.querySelector("[dir='rtl']"));
};

const CustomToaster = () => {
  const [isRTL, setIsRTL] = useState(() => detectRTL());

  useEffect(() => {
    if (
      typeof document === "undefined" ||
      typeof MutationObserver === "undefined"
    ) {
      return;
    }

    const updateRTL = () => {
      setIsRTL(detectRTL());
    };

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.attributeName === "dir")) {
        updateRTL();
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      subtree: true,
      attributeFilter: ["dir"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Toaster
      position="top-center"
      richColors
      toastOptions={{
        className: isRTL ? RTL_TOAST_CLASS : undefined,
      }}
    />
  );
};

export { toast } from "sonner";
export default CustomToaster;
